export default __webpack_public_path__ + "static/ambassador-hero-a5a3e65933242fcc1cc1772bd85f039b.png";